import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import asyncRoute from '../../helpers/hoc/asyncRoute';
import resourcesConfig from '../../resources';

import './SessionExpiredPopover.scss'

const MaterialModal = asyncRoute(() => import('../../components/MaterialElements/Modal'));

const SessionExpiredPopover = ({ open, onCTAClick }) => {
  return (
    <MaterialModal
      open={open}
      className="session-expired-popover"
      content={{
        title: (
          <FormattedMessage
            id="sessionExpiryPopoverTitle"
            defaultMessage={resourcesConfig.sessionExpiryPopoverTitle}
          />
        ),
        description: (
          <FormattedMessage
            id="sessionExpiryPopoverDescription"
            defaultMessage={resourcesConfig.sessionExpiryPopoverDescription}
          />
        ),
        CTAs: {
          primaryCTA: (
            <FormattedMessage
              id="sessionExpiryPopoverCTA"
              defaultMessage={resourcesConfig.sessionExpiryPopoverCTA}
            />
          ),
        },
      }}
      onPrimaryCTAClick={onCTAClick}
    />
  );
};

export default SessionExpiredPopover;

SessionExpiredPopover.prototypes = {
  open: PropTypes.bool,
  onCTAClick: PropTypes.func,
};

SessionExpiredPopover.defaultProps = {
  open: false,
  onCTAClick: () => {},
};
